import * as React from 'react';

import {UpgradePillButton} from 'shells/limits/upgrade-pill-button';

import {TeamsFeatureGate} from '../../../limits/feature-gates/teams-feature-gate';

export function TeamsUpsellButton() {
    const [isFeatureGateOpen, setIsFeatureGateOpen] = React.useState(false);

    return (
        <>
            <UpgradePillButton
                onClick={() => {
                    setIsFeatureGateOpen(true);
                }}
            />
            {isFeatureGateOpen && (
                <TeamsFeatureGate
                    isOpen={isFeatureGateOpen}
                    onClose={() => {
                        setIsFeatureGateOpen(false);
                    }}
                />
            )}
        </>
    );
}
